// Global wait function (safe loader for jQuery + tns)
function waitFor(conditionFn, callback, checkInterval = 25, timeout = 6000) {
  const start = Date.now();
  (function check() {
    if (conditionFn()) return callback();
    if (Date.now() - start >= timeout) {
      console.warn("⛔ waitFor(): timeout waiting for condition");
      return;
    }
    setTimeout(check, checkInterval);
  })();
}

// Main script (runs ONLY when jQuery is ready)
waitFor(() => window.jQuery && window.$, function () {
  console.log("✅ jQuery loaded — initializing scripts…");

  // Also wait for tns for slider parts
  waitFor(() => typeof tns === "function", function () {
    console.log("✅ tiny-slider loaded — initializing sliders…");
  });

  // =============== YOUR ORIGINAL SCRIPT (safe-updated) ===============
  function r(f) {
    /in/.test(document.readyState) ? setTimeout(() => r(f), 9) : f();
  }

  r(function () {
    // -----------------------------------------
    // Update captions
    // -----------------------------------------
    const updateCaption = (selector) => {
      document.querySelectorAll(selector).forEach((element) => {
        element.textContent = "Usually ready in 2-4 Weeks for bulky items";
      });
    };

    updateCaption(".pickup-availability-info .caption");
    updateCaption(".pickup-availability-list .caption-large");
    updateCaption("._1x52f9si");

    // -----------------------------------------
    // Subheader scroll behavior
    // -----------------------------------------
    const subheader = document.querySelector(".subheader-ext");
    window.addEventListener("scroll", () => {
      if (!subheader) return;
      window.scrollY > 350
        ? subheader.classList.remove("showing")
        : subheader.classList.add("showing");
    });

    // -----------------------------------------
    // Hamburger menu
    // -----------------------------------------
    const element = document.getElementById("che-hamburger-menu");
    const overlay = document.getElementById("che-menu-overlay");
    const body = document.body;

    if (element && overlay) {
      element.onclick = (e) => {
        e.preventDefault();
        const isActive = element.classList.toggle("active");
        overlay.classList.toggle("active", isActive);
        overlay.classList.toggle("remove", !isActive);
        body.classList.toggle("noscroll", isActive);
      };
    }

    // -----------------------------------------
    // Show hidden sections
    // -----------------------------------------
    [
      "apps-che-category-slider-wrapper",
      "che-product-slider-fridges",
      "che-product-slider-outdoor-wrapper",
      "che-home-slider-wrapper",
      "che-mouse-over-slider-container",
      "che-simple-image-banner",
      "gazebo-product-slider-wrapper",
      "che-product-slider-signature-wrapper",
    ].forEach((id) => {
      const el = document.getElementById(id);
      if (el) el.style.display = "block";
    });

    // -----------------------------------------
    // Mouse-over background preview
    // -----------------------------------------
    const collection = document.getElementsByClassName(
      "che-mouse-over-src-slider"
    );
    if (collection.length > 0) {
      const dataSrc = collection[0].getAttribute("data-src");
      const mouseOverMainElement = document.getElementById(
        "che-mouse-over-slider"
      );
      if (mouseOverMainElement && dataSrc) {
        mouseOverMainElement.style.backgroundImage = `url('${dataSrc}')`;
        mouseOverMainElement.style.backgroundPosition = "center";
        mouseOverMainElement.style.backgroundRepeat = "no-repeat";
        mouseOverMainElement.style.backgroundSize = "cover";
      }
    }

    // -----------------------------------------
    // SAFE Slider initializer
    // -----------------------------------------
    const initSlider = (container, itemsConfig) => {
      if (typeof tns !== "function") {
        console.warn("⛔ tiny-slider not ready, skipping slider:", container);
        return null;
      }

      return tns({
        container,
        items: itemsConfig.items,
        autoplay: itemsConfig.autoplay || false,
        controlsPosition: "bottom",
        autoplayButtonOutput: false,
        arrowKeys: true,
        controls: false,
        nav: itemsConfig.nav || false,
        responsive: itemsConfig.responsive,
      });
    };

    const slidersConfig = [
      {
        container: ".che-mouse-over-slider",
        items: 4,
        autoplay: true,
        responsive: {
          200: { items: 1 },
          640: { items: 2 },
          900: { items: 4 },
          1200: { items: 4 },
        },
      },
      {
        container: ".apps-che-category-slider",
        items: 7,
        responsive: {
          100: { items: 3 },
          640: { items: 3 },
          700: { items: 4 },
          900: { items: 5 },
          1200: { items: 7 },
        },
      },
      {
        container: ".che-product-slider-fridge",
        items: 7,
        responsive: {
          300: { items: 2 },
          700: { items: 4 },
          900: { items: 5 },
          1200: { items: 5 },
        },
      },
      {
        container: ".che-home-slider-container",
        items: 1,
        speed: 7000,
        autoplayTimeout: 7000,
        autoplay: true,
        autoHeight: true,
        mouseDrag: true,
        nav: true,
      },
      {
        container: ".che-simple-slider-container",
        items: 1,
        speed: 6000,
        autoplay: true,
        autoHeight: true,
        mouseDrag: true,
      },
    ];

    // Build sliders SAFE
    const sliders = slidersConfig.map((config) =>
      initSlider(config.container, config)
    );

    // -----------------------------------------
    // SAFE Slider controls
    // -----------------------------------------
    const setSliderControls = (prevId, nextId, sliderIndex) => {
      const prev = document.getElementById(prevId);
      const next = document.getElementById(nextId);

      if (prev) {
        prev.onclick = (e) => {
          e.preventDefault();
          if (sliders[sliderIndex]) sliders[sliderIndex].goTo("prev");
        };
      }

      if (next) {
        next.onclick = (e) => {
          e.preventDefault();
          if (sliders[sliderIndex]) sliders[sliderIndex].goTo("next");
        };
      }
    };

    setSliderControls("che-prev", "che-next", 1);
    setSliderControls("che-br-slider-arrow-left", "che-br-slider-arrow-right", 2);
    setSliderControls("che-ok-slider-arrow-left", "che-ok-slider-arrow-right", 5);

    // -----------------------------------------
    // Alphabet container (safe)
    // -----------------------------------------
    const cac = document.getElementById("che-alphabet-container");
    if (cac) {
      const alphabet = "#ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");
      let li = "";
      alphabet.forEach((letter) => {
        li += `<li class="${letter}">
          <span onmouseover="getData('${letter}')">${letter}</span>
          <div class="che-aphabet-list-container" id="che-aphabet-list-container-${letter}"></div>
        </li>`;
      });
      cac.innerHTML = `<ul class="che-alphabet-list">${li}</ul>`;
    }
  });

  // -----------------------------------------
  // Hide widget if present
  // -----------------------------------------
  document.addEventListener("DOMContentLoaded", () => {
    const widget = document.getElementById("fc_frame");
    if (widget) widget.style.display = "none";

    new MutationObserver(() => {
      const dynamicWidget = document.getElementById("fc_frame");
      if (dynamicWidget) dynamicWidget.style.display = "none";
    }).observe(document.body, { childList: true, subtree: true });
  });
});
